import script from "./ESIMBundles.vue?vue&type=script&lang=ts&setup=true"
export * from "./ESIMBundles.vue?vue&type=script&lang=ts&setup=true"

import "./ESIMBundles.vue?vue&type=style&index=0&id=64602ed0&lang=scss"

const __exports__ = script;

export default __exports__